import z from "zod";

export const modalAddDeliveryLabelSchema = z.object({
  fileSignedId: z
    .string()
    .optional()
    .refine((data) => data, {
      message: "modals.addDeliveryLabel.errorDropfile",
    }),
});

export type InferredModalAddDeliveryLabelSchema = z.infer<
  typeof modalAddDeliveryLabelSchema
>;
